import { Permission } from 'shared'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useRemoveNonUserEmailMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  NonUserEmail,
  useNonUserEmailsTableContext,
} from '../../../../NonUserEmailsTableContext'

export function useRemoveOptions(): RemoveRowActionOptions<NonUserEmail> {
  const { refetch } = useNonUserEmailsTableContext()
  const [removeNonUserEmail] = useRemoveNonUserEmailMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      removeNonUserEmail: {
        nonUserEmail: { label, address },
      },
    }) => simpleRemoveNotification(label ?? address),
  })

  return {
    permission: Permission.RemoveNonUserEmail,
    hard: true,
    onRemove: async ({ id }) => {
      await removeNonUserEmail({ variables: { id } })
      await refetch()
    },
  }
}
